export enum EAgentInboxQueryKey {
  AGENT_INBOX_LIST_MESSAGES = 'agent-inbox-list-messages',
  AGENT_INBOX_MARK_AS_READ = 'agent-inbox-mark-as-read',
  AGENT_INBOX_MARK_ALL_AS_READ = 'agent-inbox-mark-all-as-read',
}
